import { createGlobalStyle, css } from 'styled-components';
import Color from './Color';
import { MaxWidth } from '.';

// normalize style css
const resetStyle = css`
  @font-face {
    font-family: 'Avenir';
    src: url('/static/fonts/AvenirLTStd-Light.otf') format('opentype');
    font-weight: lighter;
    font-style: normal;
  }
  @font-face {
    font-family: 'Avenir';
    src: url('/static/fonts/AvenirLTStd-Book.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'Avenir';
    src: url('/static/fonts/AvenirLTStd-Medium.otf') format('opentype');
    font-weight: 500;
    font-style: normal;
  }
  @font-face {
    font-family: 'Avenir';
    src: url('/static/fonts/AvenirLTStd-Black.otf') format('opentype');
    font-weight: bold;
    font-style: normal;
  }
  *,
  &:after,
  &:before {
    position: relative;
    margin: 0;
    padding: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  input,
  button,
  textarea,
  select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    font: inherit;
  }
  input[type='checkbox'] {
    appearance: checkbox;
    -webkit-appearance: checkbox;
    -moz-appearance: checkbox;
  }
  input[type='radio'] {
    appearance: radio;
    -webkit-appearance: radio;
    -moz-appearance: radio;
  }
  ul,
  ol {
    margin-left: 0;
  }
  html {
    font-size: 62.5%;
    height: 100%;
  }
  body {
    background-color: ${({ theme: { colors } }) => colors.light.primary};
    color: ${({ theme: { colors } }) => colors.dark.primary};
    font-family: 'Avenir', -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue,
      Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    font-size: 18px;
    ${MaxWidth.sm`
      font-size: 16px;
    `}
    -webkit-text-size-adjust: none;
    -moz-osx-font-smoothing: grayscale;
    margin: 0;
    font-weight: 400;
    letter-spacing: 0.5px;
  }
  button {
    color: ${({ theme: { colors } }) => colors.dark.primary};
  }
  li {
    line-height: 1.6;
  }
  li + li {
    margin-top: 8px;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 600;
    margin-bottom: 16px;
  }
  h1 {
    font-size: 3.6rem;
  }
  h2 {
    font-size: 3.2rem;
  }
  h3 {
    font-size: 3rem;
  }
  h4 {
    font-size: 2.6rem;
  }
  h5 {
    font-size: 2rem;
  }
  h6 {
    font-size: 1.6rem;
  }
  p {
    line-height: 1.6;
    margin-bottom: 4px;
  }
  a {
    text-decoration: none;
    cursor: pointer;
    color: ${Color.red};
    &:hover {
      color: ${Color.redDark};
    }
  }
  label {
    font-size: 14px;
    font-weight: 600;
  }
  form {
    display: block;
    width: 100%;
  }
  strong,
  b {
    font-weight: 600;
  }
  img,
  embed,
  object,
  video {
    max-width: 100%;
  }
`;

const nProgressStyle = css`
  /* Make clicks pass-through */
  #nprogress {
    pointer-events: none;
  }

  #nprogress .bar {
    background: ${Color.red};

    position: fixed;
    z-index: 1031;
    top: 0;
    left: 0;

    width: 100%;
    height: 2px;
  }

  /* Fancy blur effect */
  #nprogress .peg {
    display: block;
    position: absolute;
    right: 0px;
    width: 100px;
    height: 100%;
    box-shadow: 0 0 10px ${Color.red}, 0 0 5px ${Color.red};
    opacity: 1;

    -webkit-transform: rotate(3deg) translate(0px, -4px);
    -ms-transform: rotate(3deg) translate(0px, -4px);
    transform: rotate(3deg) translate(0px, -4px);
  }

  /* Freshchat */
  .fc-widget-normal {
    bottom: 80px !important;
  }
`;

const utils = css`
  .fcn {
    color: ${Color.black};
  }
`;

const NormalizeStyle = createGlobalStyle`
  ${resetStyle}
  ${nProgressStyle}
  ${utils}
`;

export default NormalizeStyle;
